/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loader-overlay-container{background:rgba(255,255,255,.5);position:fixed;z-index:1051;top:0;left:0;bottom:0;right:0}"];
export { styles as styles };
